/* eslint-disable arrow-body-style */
import * as React from "react";
import {Component} from "react";

import {observer} from "mobx-react";

import {Icon} from "../../core/components/icon/icon";
import {Button, Dimmer, Form, Input, Loader, Message, Progress, Select} from "semantic-ui-react";
import {Auftragsverwaltung} from "../../stores/auftragsverwaltung-mobx";

import "./partial-order-form.scss";
import {AppState} from "../../components/app/app-mobx";

import {InputOnChangeData} from "semantic-ui-react/dist/commonjs/elements/Input/Input";
import {Project} from "../../models/project";
import {PartialOrder} from "../../models/partial-order";

export enum StatusType {
    Saving = "saving",
    Warning = "warning",
    Complete = "successful",
    Error = "error"
}

export interface PartialOrderRiskFormProps {
    appStore: AppState;
    auftragsverwaltung: Auftragsverwaltung;
    project: Project;
    onCancel?: (e: React.MouseEvent) => void;
    onSave?: (partialOrder: PartialOrder) => void;
}

@observer
export class PartialOrderRiskForm extends Component<PartialOrderRiskFormProps, any> {
    watchHandles: any[] = [];

    constructor(props: PartialOrderRiskFormProps) {
        super(props);
        this.state = {
            saveError: null,
            saveState: null,
            riskEvaluationOptions: null,
            primaryProcessTypeOptions: null,
            sideProcessTypeOptions: null,
            recurrencePeriodOptions: null,

            processSourceName: null,
            riskEvaluationId: null,
            primaryProcessTypeId: null,
            sideProcessTypeId: null,
            recurrencePeriodId: null,

            riskEvaluationIdError: false,
            primaryProcessTypeIdError: false,
            recurrencePeriodIdError: false,
            sideProcessTypeIdError: false,
            sideProcessTypeIdNotError: false,
            processSourceNameError: false,
            processSourceNameNotError: false
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSave = this.handleSave.bind(this);
    }

    componentDidMount(): void {
        const {auftragsverwaltung} = this.props;
        const partialOrder = auftragsverwaltung.selectedPartialOrderRisk;

        if (!partialOrder) {
            return;
        }

        // pass partial order properties to state. Use controlled state with form controls
        this.setState({
            processSourceName: partialOrder.processSourceName,
            riskEvaluationId: partialOrder.riskEvaluationId,
            primaryProcessTypeId: partialOrder.primaryProcessTypeId,
            sideProcessTypeId: partialOrder.sideProcessTypeId,
            recurrencePeriodId: partialOrder.recurrencePeriodId
        });

        this.loadDomains();
    }

    componentWillUnmount(): void {

    }

    render(): React.ReactElement | null {
        const {auftragsverwaltung} = this.props;
        const partialOrder = auftragsverwaltung.selectedPartialOrderRisk;

        const {
            riskEvaluationOptions,
            primaryProcessTypeOptions,
            sideProcessTypeOptions,
            recurrencePeriodOptions,
            processSourceName,
            riskEvaluationId,
            primaryProcessTypeId,
            sideProcessTypeId,
            recurrencePeriodId,
            saveError,
            saveState,
            riskEvaluationIdError,
            primaryProcessTypeIdError,
            recurrencePeriodIdError,
            sideProcessTypeIdError,
            sideProcessTypeIdNotError,
            processSourceNameError,
            processSourceNameNotError
        } = this.state;

        if (!partialOrder) {
            return null;
        }

        if (!riskEvaluationOptions) {
            return (
                <div>
                    <Dimmer active inverted>
                        <Loader inverted content="Formulardaten laden" />
                    </Dimmer>
                </div>
            );
        }

        let progress: React.ReactElement | null = null;
        if (saveState) {
            progress = (
                <Progress
                    percent={saveState === StatusType.Complete ? 100 : 50}
                    attached="bottom"
                    active={saveState === StatusType.Saving}
                    warning={saveState === StatusType.Warning}
                    error={saveState === StatusType.Error}
                    success={saveState === StatusType.Complete}
                />
            );
        }

        return (
            <div className="partial-order-form partial-order-form-risk">
                <Form size="huge" onSubmit={(e) => {
                    e.preventDefault();
                    this.handleSave(partialOrder);
                }}>
                    <Form.Group widths="equal">
                        {riskEvaluationOptions &&
                            <Form.Field
                                name="riskEvaluationId"
                                control={Select}
                                options={riskEvaluationOptions}
                                label={{
                                    children: "Beurteilungsumfang",
                                    htmlFor: "form-select-control-risk-evaluation"
                                }}
                                placeholder={"z.B. Befunde PA"}
                                search
                                clearable
                                searchInput={{ id: "form-select-control-risk-evaluation" }}
                                value={riskEvaluationId}
                                onChange={this.handleChange}
                                error={
                                    riskEvaluationIdError?
                                        { content: "Bitte einen gültigen Beurteilungsumfang auswählen" } : null
                                }
                            />
                        }
                        {primaryProcessTypeOptions &&
                            <Form.Field
                                name="primaryProcessTypeId"
                                control={Select}
                                options={primaryProcessTypeOptions}
                                label={{
                                    children: "Hauptprozessart",
                                    htmlFor: "form-select-control-primary-process-type"
                                }}
                                placeholder={"z.B. Wasserprozesse"}
                                search
                                clearable
                                searchInput={{ id: "form-select-control-primary-process-type" }}
                                value={primaryProcessTypeId}
                                onChange={this.handleChange}
                                error={
                                    primaryProcessTypeIdError?
                                        { content: "Bitte eine gültige Hauptprozessart auswählen" } : null
                                }
                            />
                        }
                        {recurrencePeriodOptions &&
                            <Form.Field
                                name="recurrencePeriodId"
                                control={Select}
                                options={recurrencePeriodOptions}
                                label={{
                                    children: "Wiederkehrperioden",
                                    htmlFor: "form-select-control-recurrence-period"
                                }}
                                placeholder={"z.B. 300, 100, 30"}
                                search
                                clearable
                                searchInput={{ id: "form-select-control-recurrence-period" }}
                                value={recurrencePeriodId}
                                onChange={this.handleChange}
                                error={
                                    recurrencePeriodIdError?
                                        { content: "Bitte gültige Wiederkehrperioden auswählen" } : null
                                }
                            />
                        }
                    </Form.Group>
                    <Form.Group widths="equal">
                        <Form.Field
                            id="form-input-control-partial-process-source-name"
                            name="processSourceName"
                            control={Input}
                            label={{
                                children: "Prozessquelle",
                                htmlFor: "form-input-control-partial-process-source-name"
                            }}
                            placeholder="z.B. 01601W1"
                            width={6}
                            value={processSourceName}
                            onChange={this.handleChange}
                            error={
                                processSourceNameError || processSourceNameNotError?
                                    {
                                        content: processSourceNameError ?
                                            "Bitte eine gültige Prozessquelle eingeben" :
                                            "Bitte keine Prozessquelle eingeben"
                                    } : null
                            }
                        />
                        {sideProcessTypeOptions &&
                            <Form.Field
                                name="sideProcessTypeId"
                                control={Select}
                                options={sideProcessTypeOptions}
                                label={{
                                    children: "Nebenprozessart",
                                    htmlFor: "form-select-control-side-process-type"
                                }}
                                placeholder={"z.B. Hangmure"}
                                search
                                clearable
                                searchInput={{ id: "form-select-control-side-process-type" }}
                                value={sideProcessTypeId}
                                onChange={this.handleChange}
                                error={
                                    sideProcessTypeIdError || sideProcessTypeIdNotError?
                                        {
                                            content: sideProcessTypeIdError ?
                                                "Bitte eine gültige Nebenprozessart auswählen" :
                                                "Bitte keine Nebenprozessart auswählen"
                                        } : null
                                }
                            />
                        }
                    </Form.Group>
                    {progress}
                    {saveState && saveState === StatusType.Complete &&
                        <Message attached="bottom" positive>
                            <Icon name={"data_floppy_disk"} />
                            Erfolgreich gespeichert!
                        </Message>
                    }
                    {saveState && saveState === StatusType.Error &&
                        <Message attached="bottom" negative>
                            <Icon name={"error"} />
                            Fehler beim Speichern! {saveError}
                        </Message>
                    }
                    <Button className={"save"} primary type="submit">
                        <Icon name={"floppy_disk"} />
                        Speichern
                    </Button>

                    <Button className={"cancel"} secondary
                        onClick={(e: React.MouseEvent) => {
                            if (this.props.onCancel) {
                                this.props.onCancel(e);
                            }
                        }}>
                        <Icon name={"navigate_cross"} />
                        Abbrechen
                    </Button>
                </Form>
            </div>
        );
    }

    handleChange(event: React.ChangeEvent<HTMLInputElement>, data: InputOnChangeData): void {
        this.setState({[data.name]: data.value});
    };

    handleSave(partialOrder: PartialOrder): void {
        const {
            appStore,
            auftragsverwaltung,
            project,
            onSave
        } = this.props;
        const {
            processSourceName,
            riskEvaluationId,
            primaryProcessTypeId,
            sideProcessTypeId,
            recurrencePeriodId
        } = this.state;

        if (!partialOrder) {
            throw new Error("Project undefined saving project");
        }

        const hasError = this.validateFormInput();
        if (hasError) {
            this.setState({formError: true});
            return;
        }

        // make progress indicator visible
        this.setState({
            saveState: StatusType.Saving
        });

        // !! do set null instead of "", otherwise it is not possible to remove previously selected values
        // because there are domains on the fields
        const updated = {
            projectId: project.id,
            processSourceName: processSourceName || null,
            riskEvaluationId: riskEvaluationId || null,
            primaryProcessTypeId: primaryProcessTypeId || null,
            sideProcessTypeId: sideProcessTypeId || null,
            recurrencePeriodId: recurrencePeriodId || null
        };

        const user = appStore.esriCredential?.userId;
        auftragsverwaltung.PartialOrderRiskStore.save(project, partialOrder, updated, user || "")
            .then((pa: PartialOrder) => {
                this.setState({
                    saveState: StatusType.Complete,
                    saveError: null
                });
                // hide form
                auftragsverwaltung.setEditing(false);
                if (onSave) {
                    onSave(pa);
                }
            }).catch((error) => {
                this.setState({
                    saveState: StatusType.Error,
                    saveError: error.message
                });
            });
    }

    /**
     * Load domains and sources for select boxes.
     *
     * @private
     */
    private loadDomains() {
        const {auftragsverwaltung} = this.props;

        const domainPromises = [
            auftragsverwaltung.getDomainAsOptions(
                "partial-order-risk",
                "riskEvaluationId"
            ),
            auftragsverwaltung.getDomainAsOptions(
                "partial-order-risk",
                "primaryProcessTypeId"
            ),
            auftragsverwaltung.getDomainAsOptions(
                "partial-order-risk",
                "sideProcessTypeId"
            ),
            auftragsverwaltung.getDomainAsOptions(
                "partial-order-risk",
                "recurrencePeriodId"
            )
        ];

        Promise.all(domainPromises).then((domains) =>{
            this.setState({
                riskEvaluationOptions: domains[0],
                primaryProcessTypeOptions: domains[1],
                sideProcessTypeOptions: domains[2],
                recurrencePeriodOptions: domains[3]
            });
        });
    }

    private validateFormInput(): boolean {
        const {
            processSourceName,
            riskEvaluationId,
            primaryProcessTypeId,
            sideProcessTypeId,
            recurrencePeriodId
        } = this.state;

        const validates = {
            processSourceNameError: false,
            riskEvaluationIdError: false,
            primaryProcessTypeIdError: false,
            sideProcessTypeIdError: false,
            sideProcessTypeIdNotError: false,
            recurrencePeriodIdError: false,
            processSourceNameNotError: false
        };
        let isError: boolean = false;

        // mandatory field
        if (!riskEvaluationId) {
            validates.riskEvaluationIdError = true;
            isError = true;
        }
        // mandatory field
        if (!primaryProcessTypeId) {
            validates.primaryProcessTypeIdError = true;
            isError = true;
        }
        // mandatory field
        if (!recurrencePeriodId) {
            validates.recurrencePeriodIdError = true;
            isError = true;
        }

        // These fields are required based on selected value in riskEvaluationId
        if (riskEvaluationId) {
            if ([3, 4].includes(riskEvaluationId)) {
                // Befunde PA | Befunde PA für Prozessquelle
                // Nebenprozess has to be set
                if (!sideProcessTypeId) {
                    validates.sideProcessTypeIdError = true;
                    isError = true;
                }
            } else {
                // Nebenprozess darf nicht gewählt sein
                if (sideProcessTypeId) {
                    validates.sideProcessTypeIdNotError = true;
                    isError = true;
                }
            }
            if ([2, 4, 6].includes(riskEvaluationId)) {
                // Befunde HPA für Prozessquelle  | Befunde PA für Prozessquelle | Befunde FDQ mit Prozessquelle
                // Prozessquelle has to be set
                if (!processSourceName) {
                    validates.processSourceNameError = true;
                    isError = true;
                }
            }
            else {
                // Prozessquelle darf nicht gewählt sein
                if (processSourceName) {
                    validates.processSourceNameNotError = true;
                    isError = true;
                }
            }
        }

        this.setState(validates);
        return isError;
    }

}
